class MonthName {
  
    month(m){
    return (m == 1)
     ? 'January' : (m == 2 ? 'February' : (m == 3 ? 'March' : (m == 4 ? 'April' : (m == 5 ? 'May' : (
       m == 6 ? 'June' : (m == 7 ? 'July' : (m == 8 ? 'August' : (m == 9 ? 'September' : (m == 10 ? 'October' : (m == 11 ? 'november' : 'December'))))))))))
 
   }
   
 }export default new MonthName()